"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// @ts-check

/**
 * @param {V2.RefundDataGrouping} _
 * @returns {V2.RefundPolicyGroupInfo}
 */
function busbudRefundTerms(_) {
  // eslint-disable-line no-unused-vars
  return {
    icon: "dollar-sign",
    method: "!refund-and-exchange.content.refund.support.method",
    method_simplified: "!refund-and-exchange.content.refund.support.method.simplified"
  };
}

exports.default = busbudRefundTerms;
module.exports = exports.default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy92Mi9yZWZ1bmRzL2J1c2J1ZC1yZWZ1bmRzLmpzIl0sIm5hbWVzIjpbImJ1c2J1ZFJlZnVuZFRlcm1zIiwiXyIsImljb24iLCJtZXRob2QiLCJtZXRob2Rfc2ltcGxpZmllZCJdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQTs7QUFFQTs7OztBQUlBLFNBQVNBLGlCQUFULENBQTJCQyxDQUEzQixFQUE4QjtBQUM1QjtBQUNBLFNBQU87QUFDTEMsVUFBTSxhQUREO0FBRUxDLFlBQVEsb0RBRkg7QUFHTEMsdUJBQW1CO0FBSGQsR0FBUDtBQUtEOztrQkFFY0osaUIiLCJmaWxlIjoiYnVzYnVkLXJlZnVuZHMuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAdHMtY2hlY2tcblxuLyoqXG4gKiBAcGFyYW0ge1YyLlJlZnVuZERhdGFHcm91cGluZ30gX1xuICogQHJldHVybnMge1YyLlJlZnVuZFBvbGljeUdyb3VwSW5mb31cbiAqL1xuZnVuY3Rpb24gYnVzYnVkUmVmdW5kVGVybXMoXykge1xuICAvLyBlc2xpbnQtZGlzYWJsZS1saW5lIG5vLXVudXNlZC12YXJzXG4gIHJldHVybiB7XG4gICAgaWNvbjogXCJkb2xsYXItc2lnblwiLFxuICAgIG1ldGhvZDogXCIhcmVmdW5kLWFuZC1leGNoYW5nZS5jb250ZW50LnJlZnVuZC5zdXBwb3J0Lm1ldGhvZFwiLFxuICAgIG1ldGhvZF9zaW1wbGlmaWVkOiBcIiFyZWZ1bmQtYW5kLWV4Y2hhbmdlLmNvbnRlbnQucmVmdW5kLnN1cHBvcnQubWV0aG9kLnNpbXBsaWZpZWRcIlxuICB9O1xufVxuXG5leHBvcnQgZGVmYXVsdCBidXNidWRSZWZ1bmRUZXJtcztcbiJdfQ==